import { Box } from "@mui/material"
import { BounceLoader  } from "react-spinners";

const override = {
  display: "block",
  margin: "0 auto",
  // borderColor: "red",
};

const AppLoader = ({ loading = true }) => {
  return (
    <Box
      sx={{
        width: '100%',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: '#ffffff57',
      }}
    >
      <BounceLoader
        color={'#36d7b7'}
        loading={loading}
        cssOverride={override}
        size={80}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
    </Box>
  )
}

export default AppLoader